module.exports = __webpack_public_path__ + "static/media/iphone-agenda.a10d2e93.png";